export const TOKEN_ENTITY_ID = '/entity_id';
export const TOKEN_LOCAL_USER_ID = '/local_user_id';

export const EMAIL_REGEXP = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,})$/;

export const CA_PRODUCT_CODES = {
    COLENDING: 'CLNDNG',
    BILL_DISCOUNTING: 'BILLDISCOUNTING',
    PLATFORM_AUTH: 'PLATFORN_AUTH',
    CRDPL: 'CRDPL',
    USS: 'USS',
};

export const STATUS_CODES = {
    500: 500,
    404: 404,
    403: 403,
    400: 400,
    201: 201,
    200: 200,
};

export const PAGE_SIZE = 10;

export const USER_TYPES = {
    ANCHOR: 'anchor',
    CUSTOMER: 'customer',
};
export const YUBI_DOMAIN = 'go-yubi';
export const CREDAVENUE_DOMAIN = 'credavenue';
export const ERR_LOGIN_REQUIRED = 'login_required';
export const NETWORK_CALL_TIMEOUT = 60 * 5 * 1000;
